// Reguli de validare pentru datele de identificare (pasul 1).
// Folosite atât la filtrarea a ceea ce se poate tasta în câmpuri (Step1DateIdentificare),
// cât și la verificarea finală de dinainte de trecerea la pasul următor (validateStep1).

export const FIELD_LIMITS = {
  nume: 256,
  telefon: 15,
  adresa: 512,
  subiect: 128,
  descriere: 1024,
  tipuriVatamareSuplimentar: 1024,
  oras: 128,
};

/** Vârsta minimă acceptată pentru depunerea unei sesizări. */
export const MIN_AGE_YEARS = 18;
export const MAX_AGE_YEARS = 120;

/** Numărul minim de cifre pentru un număr de telefon (standard internațional E.164). */
export const MIN_PHONE_DIGITS = 7;

// `\p{L}` acoperă literele din orice alfabet (diacritice românești, maghiare, germane etc.),
// nu doar A-Z. Spațiul este permis pentru că este un câmp de nume complet.
const NUME_DISALLOWED_RE = /[^\p{L}\- ]/gu;
export const NUME_PATTERN = /^[\p{L}\- ]+$/u;

// Pe lângă litere și cifre, adresele au nevoie de punctuația uzuală:
// „Str. Mihai Viteazu, nr. 5/A (bl. 3)”.
const ADRESA_DISALLOWED_RE = /[^\p{L}\p{N} \r\n.,\-\/'()#]/gu;
export const ADRESA_PATTERN = /^[\p{L}\p{N} \r\n.,\-\/'()#]+$/u;

export function sanitizeNume(value = "") {
  return value.replace(NUME_DISALLOWED_RE, "").slice(0, FIELD_LIMITS.nume);
}

export function sanitizeTelefon(value = "") {
  return value.replace(/\D/g, "").slice(0, FIELD_LIMITS.telefon);
}

export function sanitizeAdresa(value = "") {
  return value.replace(ADRESA_DISALLOWED_RE, "").slice(0, FIELD_LIMITS.adresa);
}

/** Sanitizer doar cu limită de lungime, pentru câmpurile de text liber. */
export function limitLength(limit) {
  return (value = "") => value.slice(0, limit);
}

export const sanitizeSubiect = limitLength(FIELD_LIMITS.subiect);
export const sanitizeDescriere = limitLength(FIELD_LIMITS.descriere);
export const sanitizeTipuriVatamare = limitLength(FIELD_LIMITS.tipuriVatamareSuplimentar);
export const sanitizeOras = limitLength(FIELD_LIMITS.oras);

/**
 * Adaptor peste `handleChange`-ul formularului: curăță valoarea înainte să ajungă
 * în state, ca regula să se aplice și la lipirea din clipboard, nu doar la tastare.
 */
export function createSanitizedChangeHandler(handleChange, sanitize) {
  return (event) =>
    handleChange({
      target: {
        name: event.target.name,
        value: sanitize(event.target.value),
        type: event.target.type,
      },
    });
}

/** Aceeași zi calendaristică, cu `years` ani în urmă (folosită ca prag de vârstă). */
export function subtractYears(date, years) {
  return new Date(date.getFullYear() - years, date.getMonth(), date.getDate());
}

/** Ultima dată de naștere care corespunde vârstei minime — limita superioară a calendarului. */
export function getMaxBirthDate(reference = new Date()) {
  return subtractYears(reference, MIN_AGE_YEARS);
}

export function getMinBirthDate(reference = new Date()) {
  return subtractYears(reference, MAX_AGE_YEARS);
}

/** Compară doar ziua calendaristică, ca ora curentă să nu influențeze rezultatul. */
export function isAtLeastYearsOld(birthDate, years, reference = new Date()) {
  const birthDay = new Date(birthDate.getFullYear(), birthDate.getMonth(), birthDate.getDate());
  return birthDay <= subtractYears(reference, years);
}
